export default __webpack_public_path__ + "static/media/814.8b69650e.png";